import { ReminderMailBranchType } from '@/api'

export interface OutputReminderMailRequest {
  dueDateFrom: string
  dueDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  branchType: ReminderMailBranchType
  hasReservationOnly: boolean
}

export function OutputReminderMailRequestToJSON(
  value: OutputReminderMailRequest
): any {
  return {
    due_date_from: value.dueDateFrom !== '' ? value.dueDateFrom : undefined,
    due_date_to: value.dueDateTo !== '' ? value.dueDateTo : undefined,
    branch_code_from:
      value.branchCodeFrom !== '' ? value.branchCodeFrom : undefined,
    branch_code_to: value.branchCodeTo !== '' ? value.branchCodeTo : undefined,
    branch_type: value.branchType ? value.branchType : undefined,
    has_reservation_only: value.hasReservationOnly ?? undefined
  }
}
